import { useEffect, useState } from "react";
import { Button, Card } from "flowbite-react";
import clsx from "clsx";
import { ProductSelect, AdvantageCheckIcon, Add } from "../../common/icons";
import ProductPricePoints from "./product-price-points";
import { travellerBenefits } from "../../assets/benefits/benefits";
import Helper from "../../common/helper";

import {
  AdvantagesList,
  getPWPComponent,
  returnAdvantageHeader,
} from "./multi-card";

const isCampaign1363 = Helper.isVNCampaign();

const ProductButtonMobile = ({
  isSelected,
  itemName,
  className,
  color,
  ...restProps
}) => (
  <>
    <Button
      color={color}
      className={clsx(
        `holder-title group border border-[#D1D5DB] rounded-md py-4 px-2 hover:bg-gradient-to-br hover:from-[#18A09F] hover:to-[#050033] ${className}`,
        {
          "holder-title-gradient": isSelected,
        }
      )}
      {...restProps}
    >
      <div className="flex justify-center items-center flex-col gap-3">
        <h5
          className={clsx(
            `text-sm text-[#050033] dark:text-[#FFFFFF] font-montserrat font-semibold uppercase text-center group-hover:text-[#FFF]`,
            {
              "text-[#FFFFFF]": isSelected,
            }
          )}
        >
          {itemName}
        </h5>
        {isSelected && <ProductSelect />}
      </div>
    </Button>
  </>
);

export default function ProductSelectMobile({
  benefitsTranslations,
  products,
  selectMembership,
  couponObj,
  isUserLogged,
  locationDataCurrency,
  languages,
  locationData,
  businessCategories,
  className,
}) {
  const [selectedItem, setSelectedItem] = useState({});

  const queryUrlLocation = new URLSearchParams(window.location?.search);
  const autoSelectProduct = queryUrlLocation.get("product");
  const {
    item_group_id,
    purchase_price,
    tax_amt,
    purchase_base_price,
    base_tax_amt,
    currency_text,
    item_group_name,
    priceLevel,
    item_group_components,
    component_items,
    isQbr,
  } = selectedItem || {};

  const currentItemName = item_group_name?.replace(/MEMBERSHIP/gi, "");
  const totalAmt = Number(purchase_price) + Number(tax_amt);
  const currency = currency_text || locationDataCurrency;
  const componentItems = component_items || item_group_components;
  const foc = Helper.focLength(componentItems);
  const getCoupon = Helper.checkCoupon(selectedItem, couponObj);
  const itemGroupId = item_group_id;
  const itemGroupName = item_group_name;

  const ExplorerMembership =
    itemGroupId === "4291" || itemGroupName?.includes("PARTNER EXPLORER");
  const ExplorerPlusMembership =
    itemGroupId === "4293" || itemGroupName?.includes("EXPLORER PLUS");
  const travellerMembership = item_group_name
    ?.toLowerCase()
    ?.includes("traveller");
  const DiscoveryMembership = item_group_name
    ?.toLowerCase()
    ?.includes("discovery");
  const getVoucherDetails = Helper.voucherBenefitsChecker(locationData.country);
  const isBasePrice = priceLevel?.includes("BASE PRICE");
  const PWP = Helper.newpwpCheck(
    selectedItem,
    isUserLogged,
    locationData,
    businessCategories
  );
  const isAMEX = Helper.isAMEX();
  const isSCB = Helper.isSCB();
  const popularChoice = languages.mostPopularChoice
    ? languages.mostPopularChoice
    : "Most popular choice";

  let TravellerBenefits = benefitsTranslations.benefits[0].traveller;
  let ExplorerBenefits = benefitsTranslations.benefits[1].explorer;
  let ExplorerPlusBenefits = benefitsTranslations.benefits[2]["explorer plus"];
  let DiscoveryBenefits = benefitsTranslations.benefits[3].discovery;
  console.log("ExplorerPlusBenefits", ExplorerPlusBenefits);
  console.log("Benefits2", travellerBenefits);
  useEffect(() => {
    if (autoSelectProduct) {
      let filterAutoSelectProduct;
      if (autoSelectProduct === "qantas") {
        filterAutoSelectProduct = products?.filter(
          (membership) => membership?.qbrPoints
        );
      } else {
        filterAutoSelectProduct = products?.filter((membership) =>
          membership.item_group_name?.toLowerCase().includes(autoSelectProduct)
        );
      }
      const selectProduct = filterAutoSelectProduct[0];

      if (selectProduct) {
        selectMembership(selectProduct);
        setSelectedItem(selectProduct);
      }
    } else {
      setSelectedItem(products[0]);
      selectMembership(products[0]);
    }
  }, []);

  const isMobile = true;

  return (
    <div className={`min-w-[343px] max-w-full ${className}`}>
      <Button.Group className="flex justify-start gap-2 overflow-x-auto">
        {products?.map((item, idx) => {
          const productSelect = () => {
            selectMembership(item);
            setSelectedItem(item);
          };

          const itemGroupName = item.item_group_description;
          const itemName = itemGroupName
            ?.replace(/ACCOR PLUS | MEMBERSHIP/gi, "")
            .trim();
          return (
            <ProductButtonMobile
              className={`${
                products?.length > 3 ? "min-w-[99px]" : "min-w-[109px]"
              } w-full`}
              key={item.item_group_id + idx}
              itemName={itemName}
              isSelected={item.isSelected}
              onClick={() => productSelect()}
            />
          );
        })}
      </Button.Group>

      {Object.keys(selectedItem).length ? (
        <div className="flex flex-col items-center">
          <div className=" w-full">
            <div className="item-info py-4 px-2">
              <p className="text-base tracking-tight text-[#050033] dark:text-[#FFFFFF] font-montserrat font-semibold text-center">
                {/* Best for regular traveller */}
                {selectedItem.item_group_name === "EXPLORER MEMBERSHIP" &&
                !isQbr
                  ? popularChoice
                  : ""}
              </p>
            </div>
            <ProductPricePoints
              currency={currency}
              totalAmt={totalAmt}
              isUserLogged={isUserLogged}
              isQbr={isQbr}
              languages={languages}
              PWP={PWP}
              getCoupon={getCoupon}
              item={selectedItem}
              locationData={locationData}
              getPWPComponent={getPWPComponent}
            />
            {/* <div className="py-3">
              <p className="font-montserrat font-bold">
                {languages.enjoyBenefits
                  ? languages.enjoyBenefits
                  : "ENJOY ACCOR PLUS UNIVERSAL BENEFITS"}
              </p>
            </div> */}
            <div className="flex h-full flex-col justify-center gap-2">
              <h5 className="font-semibold mt-5">
                {returnAdvantageHeader(currentItemName, languages, isMobile)}
              </h5>
              <ul className="membership-inclusions mb-5">
                {/* benefitsTranslations */}
                {foc !== 0 && isQbr && languages.qbrFreeHotel && (
                  <div className="py-3">
                    <p className="font-montserrat align-middle">
                      <Add />{" "}
                      {languages.qbrFreeHotel
                        ? languages.qbrFreeHotel
                        : "Free Hotel Night"}
                    </p>
                  </div>
                )}
                {travellerMembership &&
                  TravellerBenefits.map((advantage, id) => (
                    // console.log('advantage', advantage)
                    <li
                      key={id}
                      className={clsx({
                        "mt-4": id === 0,
                      })}
                    >
                      <AdvantagesList
                        advantageText={advantage[benefitsTranslations.region]}
                      />
                    </li>
                  ))}

                {DiscoveryMembership &&
                  DiscoveryBenefits.map((advantage, id) => (
                    <li
                      key={id}
                      className={clsx({
                        "mt-4": id === 0,
                      })}
                    >
                      <AdvantagesList
                        advantageText={advantage[benefitsTranslations.region]}
                      />
                    </li>
                  ))}
                {foc !== 0 &&
                  !isQbr &&
                  ExplorerMembership &&
                  !isSCB &&
                  ExplorerBenefits?.map(
                    (
                      advantage,
                      id // non-qbr
                    ) => (
                      <li
                        key={id}
                        className={clsx({
                          "mt-4": id === 0,
                        })}
                      >
                        <AdvantagesList
                          advantageText={advantage[benefitsTranslations.region]}
                        />
                      </li>
                    )
                  )}
                {foc !== 0 &&
                  !isQbr &&
                  ExplorerPlusMembership &&
                  ExplorerPlusBenefits.map(
                    (
                      advantage,
                      id // non-qbr
                    ) => (
                      <li
                        key={id}
                        className={clsx({
                          "mt-4": id === 0,
                        })}
                      >
                        <AdvantagesList
                          advantageText={advantage[benefitsTranslations.region]}
                        />
                      </li>
                    )
                  )}
                {/* foc !== 0 && ExplorerMembership && isQbr && (
                  <li className="inclusion-list flex items-center">
                    <div className="list-icon-holder">
                      <AdvantageCheckIcon />
                    </div>
                    <span className="list-desc text-lg">
                      {foc > 1
                        ? foc + languages.productFocAvailableMultipleMessage
                          ? languages.productFocAvailableMultipleMessage
                          : " Stay Plus complimentary nights"
                        : foc + languages.productFocAvailableSingleMessage
                        ? languages.productFocAvailableSingleMessage
                        : " Complimentary night stay at participating hotels "}
                    </span>
                  </li>
                )} */}

                {ExplorerMembership &&
                isBasePrice &&
                !ExplorerPlusMembership &&
                !isQbr &&
                languages.productBonusRewardPoints ? (
                  <li className="inclusion-list flex items-center">
                    <div className="list-icon-holder">
                      <AdvantageCheckIcon />
                    </div>
                    <span className="list-desc text-lg">
                      {languages.productBonusRewardPoints
                        ? languages.productBonusRewardPoints
                        : "Bonus 2,000 Reward Points (For a limited time)"}
                    </span>
                  </li>
                ) : (
                  <></>
                )}
                {DiscoveryMembership &&
                  getVoucherDetails[1].discovery &&
                  !isAMEX && (
                    <li>
                      <AdvantagesList
                        advantageText={
                          languages?.productVoucherBenefitsDiscovery ||
                          " Exclusive dining and accommodation discount vouchers"
                        }
                      />
                    </li>
                  )}
                {ExplorerMembership &&
                  getVoucherDetails[0].explorer &&
                  !isAMEX && (
                    <li>
                      <AdvantagesList
                        advantageText={
                          languages?.productVoucherBenefitsExplorer ||
                          " Exclusive dining and accommodation discount vouchers"
                        }
                      />
                    </li>
                  )}
                {ExplorerPlusMembership &&
                  getVoucherDetails[2].explorer_plus &&
                  !isAMEX && (
                    <li className="inclusion-list flex items-center">
                      <AdvantagesList
                        advantageText={
                          languages?.productVoucherBenefitsExplorer ||
                          " Exclusive dining and accommodation discount vouchers"
                        }
                      />
                    </li>
                  )}
                {ExplorerMembership && isCampaign1363 && (
                  <li className="flex gap-4">
                    <div>
                      <AdvantageCheckIcon className="w-6 h-6" />
                    </div>
                    <p className="font-montserrat font-normal text-base text-left">
                      Cash voucher package worth VND 2,000,000 when paying with
                      a VISA Signature or VISA Infinite card. Terms and
                      Conditions apply.
                    </p>
                  </li>
                )}
                {DiscoveryMembership && getVoucherDetails[1].discovery && (
                  <li className="inclusion-list flex items-center">
                    <div className="list-icon-holder">
                      <AdvantageCheckIcon />
                    </div>
                    <span className="list-desc text-lg">
                      {languages.productVoucherBenefitsDiscovery
                        ? languages.productVoucherBenefitsDiscovery
                        : " Exclusive dining and accommodation discount vouchers"}
                    </span>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      ) : (
        <Card> Select your membership </Card>
      )}
    </div>
  );
}
